import { render, staticRenderFns } from "./DonutChart28.vue?vue&type=template&id=321cbac7&scoped=true"
import script from "./DonutChart28.vue?vue&type=script&lang=js"
export * from "./DonutChart28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321cbac7",
  null
  
)

export default component.exports